// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c02fd73c","261":"0ddd8f1c"}[chunkId] + ".chunk.js";
};